export const ONETRUST_DOMAIN = `otto.my.onetrust.eu`
export const ONETRUST_SCRIPT_BASE_URL = `https:/*                                     */
export const ONETRUST_SCRIPT_NAME = `otSDKStub.js`
